import { MinusLight } from 'emerald-icons/dist/MinusLight';
import { PlusLight } from 'emerald-icons/dist/PlusLight';
import React, { useRef, useState } from 'react';
import { Input } from '../Input';
import { SidePanelFrame } from '../SidePanelFrame';
import {
    counterInputInputCss,
    counterInputRootCss,
    LabeledIconStyled,
    PlusMinusButton,
    plusMinusButtonIconCss
} from './Counter.styles';

export function Counter({
    icon,
    label,
    defaultInputValue = 0,
    inputId,
    plusAriaLabel = 'add item',
    minusAriaLabel = 'remove item',
    inputAriaLabel = 'item quantity',
    clearAllAriaLabel = 'remove all items',
    ...otherProps
}) {
    const [count, setCount] = useState(defaultInputValue || 0);
    const inputRef = useRef();
    const visible = count !== 0;

    return (
        <SidePanelFrame
            aria-label={inputAriaLabel}
            aria-live='polite'
            bottom={(
                <PlusMinusButton
                    aria-label={minusAriaLabel}
                    onClick={() => setCount(count - 1)}
                >
                    <MinusLight css={plusMinusButtonIconCss} />
                </PlusMinusButton>
            )}
            clearable
            clearAllAriaLabel={clearAllAriaLabel}
            middle={(
                <CounterInput
                    aria-label={inputAriaLabel}
                    count={count}
                    id={inputId}
                    inputRef={inputRef}
                    setCount={setCount}
                />
            )}
            onClearClick={() => setCount(0)}
            top={(
                <PlusMinusButton
                    aria-label={plusAriaLabel}
                    onClick={() => setCount(count + 1)}
                >
                    <PlusLight css={plusMinusButtonIconCss} />
                </PlusMinusButton>
            )}
            visible={visible}
            {...otherProps}
        >
            <LabeledIconStyled
                aria-label={inputAriaLabel}
                forwardedAs='button'
                icon={icon}
                label={label}
                onClick={() => setCount(count + 1)}
                type='button'
                visible={visible}
            />
        </SidePanelFrame>
    );
}

export const CounterInput = ({
    inputRef,
    count,
    setCount,
    ...otherProps
}) => {
    return (
        <div
            css={counterInputRootCss}
            onClick={() => inputRef.current.focus()}
        >
            <Input
                css={counterInputInputCss}
                onBlur={(e) => setCount(parseInt(e.target.value) || 0)}
                onChange={(e) => setCount(e.target.value)}
                ref={inputRef}
                value={count}
                {...otherProps}
            />
        </div>
    );
};
